/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditNotificationTemplatePage,
    allowEdit,
    allowDelete,
    openNotificationTemplateFilePage,
    setConfirmationModal,
    setCurrentItem
  }
) => (
  <>
    {allowEdit && (
      <>
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">Detail Template</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
            onClick={() => openEditNotificationTemplatePage(row.uuid)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">
              {row.is_active ? "Non Aktifkan" : "Aktifkan"}
            </Tooltip>
          }
        >
          <a
            className={`btn btn-icon btn-light btn-hover-${
              row.is_active ? "danger" : "success"
            } btn-sm mx-1`}
            onClick={() => {
              setConfirmationModal(prev => ({
                ...prev,
                updateStatus: true
              }));
              setCurrentItem(row);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              {row.is_active ? <BlockIcon /> : <CheckCircleIcon />}
            </span>
          </a>
        </OverlayTrigger>
      </>
    )}
    {allowDelete && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Hapus Template</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
          onClick={() => {
            setConfirmationModal(prev => ({ ...prev, delete: true }));
            setCurrentItem(row);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
  </>
);
